export const userLoaded = (user) => {
    return {
        type: 'USER_LOADED',
        payload: user,
    };
};

export const tourStarted = () => {
    return {
        type: 'TOUR_STARTED',
    };
};

export const tourEnded = () => {
    return {
        type: 'TOUR_ENDED',
    };
};

export const tourStepChanged = (step) => {
    return {
        type: 'TOUR_STEP_CHANGED',
        payload: step,
    };
};